<script setup lang="ts">
import GroupingsAdvantageDialog from "@/advantage/components/GroupingsAdvantageDialog.vue";

defineProps<{
    /**
     * If set to true, the button will not display the groupings advantage option.
     */
    healthcenterHasAdvantages?: boolean
}>();
</script>

<template>
  <div v-if="!healthcenterHasAdvantages" class="button-bottom">
    <GroupingsAdvantageDialog>
      <span class="text-primary">Voir les groupements partenaires</span>
    </GroupingsAdvantageDialog>
  </div>
</template>

<style scoped>

</style>